import React from 'react';
import { useHistory } from 'react-router-dom';
import { OverflowSet, IOverflowSetItemProps, IconButton, IButtonStyles, Stack, FontSizes } from '@fluentui/react';
import { Text } from '@fluentui/react';

const onRenderOverflowButton = (overflowItems: IOverflowSetItemProps[] | undefined): JSX.Element => {
  const buttonStyles: IButtonStyles = { root: { padding: '10px' } };

  return (
    <IconButton
      menuIconProps={{ iconName: 'More' }}
      role="menuitem"
      title="More options"
      styles={buttonStyles}
      menuProps={{ items: overflowItems! }}
    />
  );
};

const OverflowSetVerticalSideNav: React.FunctionComponent<{ isCollapsed: boolean }> = ({ isCollapsed }) => {
  const history = useHistory();
  const iconStyles: IButtonStyles = { icon: { fontSize: FontSizes.large } }
  const onRenderItem = (item: IOverflowSetItemProps): JSX.Element => {
    return (
      <Stack horizontal verticalAlign="center">
        <IconButton
          iconProps={{ iconName: item.icon }}
          styles={iconStyles}
          title={item.name}
          ariaLabel={item.ariaLabel}
          onClick={item.onClick}
        />
        {!isCollapsed && (
          <span role='none' onClick={item.onClick} style={{ marginLeft: 8, cursor: 'pointer' }}>
            <Text variant="medium">{item.name}</Text>
          </span>
        )}
      </Stack>
    );
  };

  return (
    <OverflowSet
      aria-label="Vertical Example"
      vertical
      items={[
        {
          key: 'item1',
          icon: 'Home',
          name: 'Home',
          title: 'Home',
          ariaLabel: 'New. Use left and right arrow keys to navigate',
          onClick: () => history.push('/')
        }
      ]}
      onRenderOverflowButton={onRenderOverflowButton}
      onRenderItem={onRenderItem}
    />
  );
};

export default OverflowSetVerticalSideNav;

